var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "6px",
    viewBox: "0 0 12 6",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 12 Copy 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-jobs",
    transform: "translate(-46.000000, -86.000000)",
    stroke: "#09165D"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12-Copy-2",
    transform: "translate(52.000000, 89.000000) rotate(90.000000) translate(-52.000000, -89.000000) translate(49.000000, 83.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: -0.75,
    y1: 3.375,
    x2: 6.75,
    y2: 3.375,
    id: "Minus-Copy-3",
    transform: "translate(3.000000, 3.375000) rotate(45.000000) translate(-3.000000, -3.375000) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: -0.75,
    y1: 8.625,
    x2: 6.75,
    y2: 8.625,
    id: "Minus-Copy-3",
    transform: "translate(3.000000, 8.625000) rotate(-45.000000) translate(-3.000000, -8.625000) "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.833c69294f6ddbf573cb275d30a68413.svg";
export { ForwardRef as ReactComponent };